// According to ARIA accessibility guidelines Tooltips should close on Escape.
// https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tooltip_role
howspace.components.toolTip = (() => {
    'use strict';

    const showTooltip = elem => {
        if (elem instanceof jQuery) {
            elem = elem[0];
        }

        // If the element is expanded, do not show the tooltip (looks nasty on top or below the expanded menu for example).
        if (elem.getAttribute('aria-expanded') === 'true') {
            return;
        }

        if (getComputedStyle(elem).getPropertyValue('--enable-tooltip') !== 'true') {
            return;
        }

        let tooltipId = elem.getAttribute('aria-describedby') || null;
        if (tooltipId !== null) {
            // Tooltip is already shown.
            return;
        }

        tooltipId = 'howspace-tooltip-' + real.uid();
        let tooltipText = null;
        if (elem.classList.contains('disabled') || elem.hasAttribute('disabled')) {
            tooltipText = elem.dataset.disabledTitle;
        }
        if (tooltipText === null || tooltipText === undefined) {
            tooltipText = elem.dataset.title;
        }
        if (tooltipText === '') {
            return;
        }
        const tooltip = $(`<div id="${tooltipId}" class="howspace-tooltip position-absolute" role="tooltip" aria-hidden="true">
            <div class="arrow-shadow"></div>
            <div class="arrow"></div>
            <div class="tooltip-inner">${tooltipText}</div>
        </div>`)[0];

        elem.dataset.flipVertical = 'true';
        if (!elem.dataset.placement) {
            elem.dataset.placement = 'top';
        }
        elem.setAttribute('aria-describedby', tooltipId);
        elem.after(tooltip);

        howspace.popover.open(elem, tooltip);
    };

    const hideTooltip = elem => {
        const tooltipId = elem.getAttribute('aria-describedby') || null;
        if (tooltipId === null) {
            return;
        }

        elem.removeAttribute('aria-describedby');
        const tooltip = document.getElementById(tooltipId);
        if (tooltip === null) {
            return;
        }

        howspace.popover.close(elem, tooltip);
        tooltip.remove();
    };

    document.body.addEventListener('keyup', e => {
        if (e.key === 'Escape') {
            const tooltip = e.target;
            const tooltipId = tooltip?.getAttribute('aria-describedby') || null;
            if (tooltipId !== null) {
                hideTooltip(tooltip);
            }
        }
    });

    document.addEventListener('mouseenter', e => {
        const tooltip = e.target;
        if (tooltip?.classList?.contains('tooltip')) {
            showTooltip(tooltip);
        }
    }, {capture: true});

    document.addEventListener('mouseleave', e => {
        const tooltip = e.target;
        if (tooltip?.classList?.contains('tooltip')) {
            hideTooltip(tooltip);
        }
    }, {capture: true});

    document.addEventListener('click', e => {
        const tooltip = e.target;
        if (tooltip?.classList?.contains('tooltip')) {
            hideTooltip(tooltip);
        }
    }, {capture: true});

    document.addEventListener('focus', e => {
        const tooltip = e.target;
        if (tooltip?.classList?.contains('tooltip')) {
            showTooltip(tooltip);
        }
    }, {capture: true});

    document.addEventListener('blur', e => {
        const tooltip = e.target;
        if (tooltip?.classList?.contains('tooltip')) {
            hideTooltip(tooltip);
        }
    }, {capture: true});

    return {
        enable: (tooltip) => {
            if (tooltip instanceof jQuery) {
                tooltip = tooltip[0];
            }
            if (!tooltip) {
                return;
            }
            tooltip.classList.add('tooltip');
            if (tooltip.dataset.originalTitle) {
                tooltip.dataset.title = tooltip.dataset.originalTitle || '';
                delete tooltip.dataset.originalTitle;
            }
        },
        disable: (tooltip) => {
            if (tooltip instanceof jQuery) {
                tooltip = tooltip[0];
            }
            if (!tooltip) {
                return;
            }
            hideTooltip(tooltip);
            tooltip.classList.remove('tooltip');
            if (tooltip.dataset.title) {
                tooltip.dataset.originalTitle = tooltip.dataset.title || '';
                delete tooltip.dataset.title;
            }
        },
        update: (tooltip, title) => {
            if (tooltip instanceof jQuery) {
                tooltip = tooltip[0];
            }
            if (!tooltip) {
                return;
            }
            tooltip.dataset.title = title;
            const tooltipId = tooltip.getAttribute('aria-describedby') || null;
            if (tooltipId !== null) {
                const tooltipElem = document.getElementById(tooltipId);
                if (tooltipElem !== null) {
                    tooltipElem.querySelector('.tooltip-inner').textContent = title;
                }
            }
        },
        show: (tooltip) => {
            showTooltip(tooltip);
        },
        hide: (tooltip) => {
            hideTooltip(tooltip);
        }
    };
})();
